export function LoadingState() {
  return (
    <div style={{
      marginTop: '24px',
      border: '1px solid var(--border)',
      borderRadius: '14px',
      padding: '48px 24px',
      textAlign: 'center',
      background: 'var(--bg-card)',
    }}>
      <div style={{
        width: '32px', height: '32px',
        border: '2px solid var(--border)',
        borderTop: '2px solid var(--accent)',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
        margin: '0 auto 16px',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{
        fontSize: '15px', fontWeight: 600,
        fontFamily: "'Outfit', sans-serif",
        color: 'var(--text-primary)', marginBottom: '6px',
        margin: 0,
      }}>
        Improving your message
      </p>
      <p style={{ fontSize: '13px', color: 'var(--text-muted)', margin: 0, marginTop: '6px' }}>
        Crafting two executive-ready variants for you
      </p>
      <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '12px', opacity: 0.6, margin: 0 }}>
        This usually takes a few seconds
      </p>
    </div>
  );
}
